import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "alert-comp" }
const _hoisted_2 = { class: "alert-frame" }
const _hoisted_3 = {
  key: 0,
  class: "btn-row"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "btn-row"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertComp',
  props: {
  text: {
    default: ''
  },
  options: {
    default: {
      buttons: [],
      font: {
        className: '',
      },
    },
  }
},
  emits: ['confirm'],
  setup(__props, { emit: __emit }) {

const emits = __emit
const props = __props
const actionBtn = (action: any) => {
  if (action) action()
  emits('confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["text-area", [__props.options?.font?.className]])
      }, _toDisplayString(_ctx.$t(props.text ? props.text : '')), 3),
      (__props.options.buttons?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options.buttons, (button, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "confirm-btn",
                onClick: ($event: any) => (actionBtn(button.onClick)),
                style: _normalizeStyle({ color: button.color })
              }, _toDisplayString(_ctx.$t(button?.text ? button.text : '')), 13, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "confirm-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('confirm')))
            }, _toDisplayString(_ctx.$t('common.confirm')), 1)
          ]))
    ])
  ]))
}
}

})